import { render, staticRenderFns } from "./ItemsReplyList.vue?vue&type=template&id=587b411e&scoped=true&"
import script from "./ItemsReplyList.vue?vue&type=script&lang=js&"
export * from "./ItemsReplyList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsReplyList.vue?vue&type=style&index=0&id=587b411e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b411e",
  null
  
)

export default component.exports